import * as React from 'react';
import { AnchorTracked, ButtonTracked, LinkTracked } from '../../../utils/click-trackers';
import { ActivityMessageDialog } from '../activity-message-dialog';
import { ACTIVITY_LINK_CLICK_ACTION, ACTIVITY_POPUP_CLICK_ACTION } from '.';
import { trackAction } from './activity-message-banner-helper';
export function ActivityMessageBannerLink(activityMessageAction, analyticsStore, openInNewWindow) {
  var messageBannerLink = React.createElement(React.Fragment, null);
  var clickAction = activityMessageAction.clickAction;
  var analytics = clickAction === null || clickAction === void 0 ? void 0 : clickAction.analytics;
  var leftPositionModifier = 535;
  var topPositionModifier = 192;
  var width = '640px';
  var height = '700px';
  var windowDimensions = {
    getLeft: function (lWidth) {
      return (lWidth - leftPositionModifier) / 2;
    },
    getTop: function (tHeight) {
      return (tHeight - topPositionModifier) / 2;
    },
    width: width,
    height: height
  };
  var handleClick = React.useCallback(function () {
    trackAction.bind(null, analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, analyticsStore);
    var leftPosition = windowDimensions.getLeft(screen.width);
    var topPosition = windowDimensions.getTop(screen.height);
    if (clickAction.__typename === ACTIVITY_LINK_CLICK_ACTION) {
      window.open((clickAction === null || clickAction === void 0 ? void 0 : clickAction.linkTagUrl) || '', 'ModalPopUp', "toolbar=no,\n        scrollbars=no,\n        location=no,\n        statusbar=no,\n        menubar=no,\n        resizable=no,\n        width=".concat(windowDimensions.width, ",\n        height=").concat(windowDimensions.height, ",\n        screenX=").concat(leftPosition, ",\n        screenY=").concat(topPosition, ",\n        left=").concat(leftPosition, ",\n        top=").concat(topPosition));
      window.focus();
    }
  }, []);
  if (clickAction.__typename === ACTIVITY_LINK_CLICK_ACTION && clickAction.anchorTagUrl && openInNewWindow) {
    messageBannerLink = React.createElement(ButtonTracked, {
      onClick: handleClick,
      target: "_blank",
      className: 'uitk-type-300 uitk-link',
      rfrr: "",
      linkName: ""
    }, activityMessageAction.text, clickAction.accessibilityText && React.createElement("span", {
      className: "is-visually-hidden"
    }, clickAction.accessibilityText));
  } else if (clickAction.__typename === ACTIVITY_LINK_CLICK_ACTION && clickAction.anchorTagUrl) {
    messageBannerLink = React.createElement(AnchorTracked, {
      linkName: analytics === null || analytics === void 0 ? void 0 : analytics.linkName,
      rfrr: analytics === null || analytics === void 0 ? void 0 : analytics.referrerId,
      href: clickAction.anchorTagUrl,
      target: clickAction.opensInNewTab ? '_blank' : '_self',
      rel: "noopener",
      className: "uitk-type-300",
      "data-testid": "activity-message-banner-anchor-link"
    }, activityMessageAction.text, clickAction.accessibilityText && React.createElement("span", {
      className: "is-visually-hidden"
    }, clickAction.accessibilityText));
  } else if (clickAction.__typename === ACTIVITY_LINK_CLICK_ACTION) {
    messageBannerLink = React.createElement(LinkTracked, {
      rfrr: analytics === null || analytics === void 0 ? void 0 : analytics.referrerId,
      linkName: analytics === null || analytics === void 0 ? void 0 : analytics.linkName,
      to: clickAction.linkTagUrl,
      onClick: trackAction.bind(null, analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, analyticsStore),
      className: "uitk-type-300",
      "data-testid": "activity-message-banner-router-link"
    }, activityMessageAction.text, clickAction.accessibilityText && React.createElement("span", {
      className: "is-visually-hidden"
    }, clickAction.accessibilityText));
  } else if (clickAction.__typename === ACTIVITY_POPUP_CLICK_ACTION) {
    messageBannerLink = React.createElement(ActivityMessageDialog, {
      activityMessageAction: activityMessageAction
    });
  } else {
    messageBannerLink = React.createElement(LinkTracked, {
      rfrr: analytics === null || analytics === void 0 ? void 0 : analytics.referrerId,
      linkName: analytics === null || analytics === void 0 ? void 0 : analytics.linkName,
      to: '#',
      onClick: trackAction.bind(null, analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, analyticsStore),
      className: "uitk-type-300",
      "data-testid": "activity-message-banner-router-link"
    }, activityMessageAction.text);
  }
  return messageBannerLink;
}